import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {Grid, OrderedList, ThemeProvider} from '@primer/react-brand'
import {PricingTable} from './PricingTable'
import {PricingCards} from './PricingCards'

export function CopilotPlansIndex() {
  const {copilotSignupPath} = useRoutePayload<{copilotSignupPath: string}>()
  const {copilotForBusinessSignupPath} = useRoutePayload<{copilotForBusinessSignupPath: string}>()
  const {copilotContactSalesPath} = useRoutePayload<{copilotContactSalesPath: string}>()

  return (
    <>
      <ThemeProvider colorMode="dark" className="lp-Copilot">
        <section id="pricing" className="lp-Section lp-Section--pricing">
          <PricingCards
            copilotSignupPath={copilotSignupPath}
            copilotForBusinessSignupPath={copilotForBusinessSignupPath}
            copilotContactSalesPath={copilotContactSalesPath}
          />
        </section>

        <section className="lp-Section pt-0">
          <PricingTable
            copilotSignupPath={copilotSignupPath}
            copilotForBusinessSignupPath={copilotForBusinessSignupPath}
            copilotContactSalesPath={copilotContactSalesPath}
          />
        </section>

        <section id="footnotes" className="lp-Section" style={{paddingTop: '0'}}>
          <Grid className="lp-Grid--noRowGap">
            <Grid.Column span={12}>
              <OrderedList>
                <OrderedList.Item className="lp-Footnotes-item">
                  <a
                    className="lp-Link--inline"
                    href="https://docs.github.com/en/enterprise-cloud@latest/authentication/authenticating-with-saml-single-sign-on/about-authentication-with-saml-single-sign-on"
                  >
                    Authentication with SAML single sign-on (SSO)
                  </a>{' '}
                  available for organizations using GitHub Enterprise Cloud.
                </OrderedList.Item>
              </OrderedList>
            </Grid.Column>
          </Grid>
        </section>
      </ThemeProvider>
    </>
  )
}

try{ CopilotPlansIndex.displayName ||= 'CopilotPlansIndex' } catch {}